import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import cx from 'classnames'

import { Tab } from '../design-system/Tab'
import { switchTo } from './actions'
import { SettingsPopupOpenSection } from '../../store/modals'
import { useOpenModalOpenSection } from '../../store/modals/hooks/useOpenModalOpenSection'

type Props = {
  section: SettingsPopupOpenSection
  label: string
  className?: string
  order?: number
}

export const SettingsPopupTab: FC<Props> = ({ label, section, className, order }) => {
  const dispatch = useDispatch()
  const openSection = useOpenModalOpenSection()

  return (
    <Tab
      size={18}
      label={label}
      className={cx(`e2e-${section}-tab`, className)}
      active={openSection === section}
      onClick={() => dispatch(switchTo(section))}
      order={order}
    />
  )
}

export type SettingsPopupTabProps = Props
